module.exports = __webpack_public_path__ + "img/Mauritius.2787e48d.svg";